import { Country } from '@backmarket/http-api'

export const FIELD_NOT_DISPLAYED = null
export const DEFAULT_PHONE_CODE = Country.US
